import range from "lodash/range";
import { isLocal, isDev } from "./envs.utils";

export const SESSION_EXPIRED_ERROR_CODE = 408;
export const REDIRECT_ERROR_CODE = 409;
export const VALIDATION_ERROR_CODE = 422;
export const UNAUTHORIZED_ACCESS_ERROR_CODE = 423;
export const INVALID_ONBOARDING_ERROR_CODE = 412;
export const SCA_TRANSMIT_ERROR_CODE = 403;
export const INVALID_APP_AUTH_TOKEN = 401;

export const blockingErrorStatuses = [
  SESSION_EXPIRED_ERROR_CODE,
  INVALID_ONBOARDING_ERROR_CODE,
  UNAUTHORIZED_ACCESS_ERROR_CODE,
  ...range(500, 599),
];

export const noAlertErrors = [
  INVALID_APP_AUTH_TOKEN,
  SCA_TRANSMIT_ERROR_CODE,
  VALIDATION_ERROR_CODE,
  REDIRECT_ERROR_CODE,
].concat(...blockingErrorStatuses);

export const errorLogger = (args: unknown) => {
  if (isLocal || isDev) {
    console.error("----------[ERR OCCURRED] --------");
    console.table(args);
  }
};
